import { LinearProgress } from "@mui/material";
import { FC } from "react";

import { MuiTopProgressLandingStyled } from "./mui-top-progress-landing.styled";

export const MuiTopProgressLanding: FC = () => {
  return (
    <MuiTopProgressLandingStyled>
      <LinearProgress />
    </MuiTopProgressLandingStyled>
  );
};
